module.exports = __webpack_public_path__ + "img/stage-logo.87c2cba7.png";